import { render } from "./WODetails.vue?vue&type=template&id=891afb2c"
import script from "./WODetails.vue?vue&type=script&lang=js"
export * from "./WODetails.vue?vue&type=script&lang=js"

import "./WODetails.vue?vue&type=style&index=0&id=891afb2c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__